import Vue from 'vue'
import ToastComponent from './toast'
function merge(target) {
  for (let i = 1, j = arguments.length; i < j; i++) {
    let source = arguments[i] || {};
    for (let prop in source) {
      if (source.hasOwnProperty(prop)) {
        let value = source[prop];
        if (value !== undefined) {
          target[prop] = value;
        }
      }
    }
  }
  return target;
};
let instance;
let showing = false;
let ToastConstructor = Vue.extend(ToastComponent);

/* 初始化 instance, 并且 append 到页面里面 */
let initInstance = () => {
  instance = new ToastConstructor({
    el: document.createElement('div')
  });
  document.body.appendChild(instance.$el);
}

let Toast = (msg, options={})=>{
  /* 如果当前已经在显示的话, 不响应*/
  if (!showing) {
    showing = true;
    initInstance();
    instance.msg = msg;
    merge(instance.$data, options);

    /* 显示 */
    instance.show = true;
    setTimeout(()=>{
      showing = false;
      instance.show = false;
    }, instance.duration);
  }
}
export  default Toast



// WEBPACK FOOTER //
// ./src/plugins/toast/index.js